import {
  blockTerminalApi,
  cardsCountApi,
  getDeployedBalance as getDeployedBalanceApi,
  getTerminalsApi,
  lookupTerminalApi,
  merchantsCountApi,
  redeemedBalanceApi,
  terminalsCountApi,
  type PosByTreasury,
} from "../utils/AxiosUtil";
import type { NetworkType } from "../utils/network";
import type { DeployedBalance } from "../types/deployedBalance";
async function getDeployedBalance(
  network: NetworkType,
  token?: string,
): Promise<DeployedBalance> {
  try {
    const res = await getDeployedBalanceApi(network, token);
    return res.data as DeployedBalance;
  } catch (error: any) {
    throw new Error("Failed to get deployed balance");
  }
}

async function getRedeemedBalance(
  network: NetworkType,
  token?: string,
): Promise<number> {
  const res = await redeemedBalanceApi(network, token);
  return res.data;
}

async function getCardsCount(network: NetworkType): Promise<number> {
  const res = await cardsCountApi(network);
  return res.data;
}

async function getMerchantsCount(
  treasuryId: string,
  network: NetworkType,
): Promise<number> {
  const res = await merchantsCountApi(treasuryId, network);
  return res.data;
}

// /posCountByTreasury answers with the full pos→merchant→treasury breakdown; the KPI wants the
// one total out of it. Returning res.data here typechecked only because an untyped
// apiClient.get yields `any` — and the object reached JSX, which React refuses to render.
async function getTerminalsCount(
  treasuryId: string,
  network: NetworkType,
): Promise<number> {
  const res = await terminalsCountApi(treasuryId, network);
  return res.data.posCount;
}

async function getTerminals(
  treasuryId: string,
  network: NetworkType,
): Promise<PosByTreasury[]> {
  const res = await getTerminalsApi(treasuryId, network);
  return res.data;
}

async function lookupTerminal(
  treasuryId: string,
  serial: string,
  network: NetworkType,
) {
  const res = await lookupTerminalApi(treasuryId, serial, network);
  return res.data;
}

async function blockTerminal(serialId: string, network: NetworkType) {
  const res = await blockTerminalApi(serialId, network);
  return res.data;
}

const issuer_services = {
  getDeployedBalance,
  getRedeemedBalance,
  getCardsCount,
  getMerchantsCount,
  getTerminalsCount,
  getTerminals,
  lookupTerminal,
  blockTerminal,
};

export default issuer_services;
